<template>
  <div class="course_scheduling_holder">
    <div class="flex flex-wrap">
      <div class="each_block xl:w-1/3 lg:w-1/2 w-full p-4">
        <h4 class="mb-2">Tell us when you are available?</h4>
        <p>Select preferred day</p>
        <div class="mt-5 mb-4">
          <label class="vs-input--label">Select Teacher</label>
          <v-select
          class="w-full"
          @input="fetchTimeSlot"
          v-model="teacher_id"
          :reduce="(option) => option.id"
          :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
          placeholder="Select Teacher"
          :clearable="false"
          :options="tutors"
        >
          <template v-slot:selected-option="tutors">
            <img
              v-if="tutors.picture"
              class="person-img rounded-full"
              :src="tutors.picture"
            />
            <img
              v-else
              class="person-img rounded-full"
              src="@/assets/images/pages/user-circle-solid.svg"
            />
            {{ tutors.first_name }}
            {{ tutors.last_name }}
          </template>
          <template v-slot:option="tutors">
            <img
              v-if="tutors.picture"
              class="person-img rounded-full"
              :src="tutors.picture"
            />
            <img
              v-else
              class="person-img rounded-full"
              src="@/assets/images/pages/user-circle-solid.svg"
            />
            {{ tutors.first_name }}
            {{ tutors.last_name }}
          </template>
        </v-select>
        </div>
        <div>
          <h5>Days</h5>
          <template v-for="(time_slot, index) in time_slots">
            <div :class="`each_time_slot_holder ${time_slot.status !== 'Available' ? 'disable' : ''}`" :key="index">
              <div class="flex flex-wrap justify-between my-4">
                <vs-checkbox  @change="checkDay(index, available_times[index].is_select)" v-model="available_times[index].is_select" :disabled="time_slot.status == 'Unavailable'"></vs-checkbox>
                <div class="each_day">{{ time_slot.day }}</div>
                <div class="pr-4">
                  <vs-checkbox v-model="available_times[index].any_time">Any Time</vs-checkbox>
                </div>
              </div>

              <div v-if="available_times[index].is_select && !available_times[index].any_time" class="flex flex-wrap justify-between">
                <div class="lg:w-1/2 w-full p-2">
                  <div class="flatpickr_with_icon">
                    <flat-pickr
                      placeholder="Start Time"
                      v-model="available_times[index].from_time"
                      :config="{
                        minTime: time_slot.from_time,
                        enableTime: true,
                        enableSeconds: false,
                        noCalendar: true,
                        maxTime: time_slot.to_time,
                        onChange: (selectedDates, dateStr, instance) => {
                          callfunc(dateStr, index, 'from_time');
                        },
                      }"
                      label="From"
                      style="min-width: 110px"
                      class="w-full"
                    />
                    <vs-icon icon-pack="feather" icon="icon-clock" />
                  </div>
                  <small style="color: red;" class="block text-center" v-if="!available_times[index].from_time">
                    Earliest time available {{ time_slot.from_time.slice(0, -3) }}
                  </small>
                </div>
                <div class="lg:w-1/2 w-full p-2">
                  <div class="flatpickr_with_icon">
                    <flat-pickr
                    v-model="available_times[index].to_time"
                    :disabled="time_slot.status == 'Unavailable'"
                    :config="{
                      minTime: available_times[index].from_time,
                      enableTime: true,
                      enableSeconds: false,
                      noCalendar: true,
                      maxTime: time_slot.to_time,
                      onChange: (selectedDates, dateStr, instance) => {
                        callfunc(dateStr, index, 'to_time');
                      },
                    }"
                    label="Untill"
                    style="min-width: 110px"
                    placeholder="End time"
                    class="w-full"
                    />
                    <vs-icon icon-pack="feather" icon="icon-clock" />
                  </div>
                  <small style="color: red" class="block text-center"  v-if="!available_times[index].to_time"> 
                    Latest time available {{ time_slot.to_time.slice(0, -3) }}
                  </small>
                </div>
              </div>
            </div>
          </template>
          <vs-button @click="bookSlots" class="block ml-auto">Next</vs-button>

        </div>
      </div>
      <div class="each_block xl:w-1/3 lg:w-1/2 w-full p-4">
          <h4 class="mb-2">Your chosen schedule</h4>
          <p class="mb-4">Select preferred Time</p>
          <div class="" v-if="course_start_date">
              <flat-pickr @input="fetchTimeByDate"
              class="flatpickr mb-2"
               v-model="course_start_date" :config="config"></flat-pickr>
          </div>
      </div>
      <div class="each_block xl:w-1/3 w-full p-4">
          <p class="pt-6 pb-4">Choose your available time slot</p>
          <div style="border-right: none" class="time_zone_holder" v-if="overall_status">
              <template v-for="(eachtime, index) in availabilityTime">
                  <vs-radio
                  @change="choosenSchedule"
                  class="mr-2 mb-2"
                :class="[eachtime.status == 'Available' ? '' : 'disabled']"
                :disabled="eachtime.status !== 'Available'"
                :key="index"
                v-model="timeSlot"
                vs-name="timezone"
                :vs-value="eachtime"
              >
                <div class="bg-grey">
                  {{ eachtime.from_time.slice(0,-3) }} - {{ eachtime.to_time.slice(0,-3) }}
                </div>
                  </vs-radio>
                  <p
                v-if="availabilityTime.length == 0"
                style="opacity: 0.7"
                :key="index"
              >
                No dates selected yet
              </p>
              </template>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { fetchEnrollmentAvailability, chooseSlotToBook, bookenrollmentSlots, choosenSlot } from '@/api/enrollment.js'
export default {
  props: {
    courseDetails:{
      default:[]
    },
    selected_course_id: null,
    counter: {
      default: 0
    }
  },
  mounted () {
    
  },
  data () {
    return {
      durationsArray: [
        {
          id: 1,
          name: 15
        },
        {
          id: 2,
          name: 30
        },
        {
          id: 3,
          name: 45
        },
        {
          id: 4,
          name: 60
        },
        {
          id: 5,
          name: 75
        },
        {
          id: 6,
          name: 90
        },
        {
          id: 7,
          name: 'Custom'
        }
      ],
      timeSlot:null,
      tutors: [],
      overall_status:false,
      time_error_holder_show: false,
      availabilityTime:[],
      customer_id:localStorage.getItem('customer_id'),
      course_start_date:null,
      config: {
        inline: true
      },
      time_slots: null,
      available_times: [
        {
          day: 'Monday',
          is_select: false,
          from_time: null,
          to_time: null,
          any_time: false,
          available: true
        },
        {
          day: 'Tuesday',
          is_select: false,
          from_time: null,
          to_time: null,
          any_time: false,
          available: false
        },
        {
          day: 'Wednesday',
          is_select: false,
          from_time: null,
          to_time: null,
          any_time: false,
          available: true
        },
        {
          day: 'Thursday',
          is_select: false,
          from_time: null,
          to_time: null,
          any_time: false,
          available: true
        },
        {
          day: 'Friday',
          is_select: false,
          from_time: null,
          to_time: null,
          any_time: false,
          available: false
        },
        {
          day: 'Saturday',
          is_select: false,
          from_time: null,
          to_time: null,
          any_time: false,
          available: true
        },
        {
          day: 'Sunday',
          is_select: false,
          from_time: null,
          to_time: null,
          any_time: false,
          available: true
        }
      ],
      teacher_id:null

    }
  },
  components: {
    vSelect,
    flatPickr
  },
  watch: {
    counter () {
      if (this.counter) {
        if (['offline_one_2_one', 'online_one_2_one'].includes(this.courseDetails.course_class_type)) {
          this.fetchTimeSlot()
          this.tutors = this.courseDetails.tutors
        }
        
      }
    }
  },
  methods: { 
    async choosenSchedule () {
      const payload = {
        course_start_date:this.course_start_date,
        ...this.slotData,
        slot: {
          from_time: this.timeSlot.from_time,
          to_time: this.timeSlot.to_time
        }

      }
      const {data} = await choosenSlot(this.customer_id, this.courseDetails.id, payload)
      this.$emit('scheduled',  data.data, payload, this.teacher_id)
    },
    async bookSlots () {
      try {
        this.$vs.loading()
        const available_slots_for_booking = this.available_times
          .map((time, index) => {
            if (time.any_time) {
              time.from_time = this.time_slots[index].from_time
              time.to_time = this.time_slots[index].to_time
            }
            time.day = this.time_slots[index].day

            return time
          })
          .filter((ele) => {
            if (ele.is_select === true) {
              return ele
            }
          })
        const available_slots_for_booking_payload = []
        available_slots_for_booking.forEach((ele) => {
          if (
            ele.from_time === '' ||
          ele.to_time === '' ||
          ele.from_time === null ||
          ele.to_time === null
          ) {
            this.$vs.notify({
              title: 'Warning',
              text: 'Please select a time',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 3000
            })
            return
          }
          available_slots_for_booking_payload.push({
            from_time:
            ele.from_time.length < 8 ? `${ele.from_time}:00` : ele.from_time,
            to_time: ele.to_time.length < 8 ? `${ele.to_time}:00` : ele.to_time,
            day: ele.day,
            any_time: ele.any_time
          })
        })
        const payload = {}

        payload.available_times = available_slots_for_booking_payload
        if (this.teacher_id !== null) {
          payload.teacher_id = this.teacher_id
        }
        const teacher_details = this.tutors.filter(
          (tutor) => tutor.id === this.teacher_id
        )

        const { data } = await bookenrollmentSlots(
          this.customer_id,
          this.selected_course_id,
          payload
        )

        console.log(data.data)
        this.course_start_date = data.data.approximate_start_date
        this.teacher_id = data.data.teacher_id

        this.slotData = Object.assign({}, data.data, payload)
        
        this.$vs.loading.close()
      } catch (e) {
        this.showSuccessMessage(
          'Warning',
          'Something went wrong',
          'warning',
        )
        this.$vs.loading.close()

      }
    
    },
    async checkDay (index, check) {
      this.available_times[index].any_time = check
      console.log(this.available_times[index])
      if (!this.available_times[index].is_select) {
        this.available_times[index].from_time = null
        this.available_times[index].to_time = null
      }
    },
    async callfunc (dateStr, index, type) {
      if (type === 'from_time') this.available_times[index].from_time = dateStr
      else this.available_times[index].to_time = dateStr

      if (
        this.available_times[index].from_time !== null &&
        dateStr !== null &&
        this.available_times[index].to_time !== null
      ) {
        const startTime = await this.$moment(
          this.available_times[index].from_time,
          'HH:mm:ss a'
        )
        const endTime = await this.$moment(
          this.available_times[index].to_time,
          'HH:mm:ss a'
        )
        const diff = await this.$moment.duration(endTime.diff(startTime))
        const hours = parseInt(diff.asHours()) * 60
        const minutes = parseInt(diff.asMinutes()) % 60

        if (
          this.courseDetails.session_duration !== null
        ) {
          this.duration = this.durationsArray.filter(
            (ele) => ele.id ===
              this.courseDetails.session_duration
          )
        }
        this.time_error_holder_show[index] =
          this.duration[0].name > minutes + hours

        return this.time_error_holder_show
      }
    },
    async fetchTimeByDate () {
      this.fetchTime(this)
    },
    fetchTime: _.debounce(async (vm) => {
      try {
        vm.fetchToChooseTime()
      } catch (e) {
        console.log(e)
      }
    }, 1000),
    async fetchToChooseTime () {
      const payload = {
        course_start_date:this.course_start_date,
        ...this.slotData
      }
      const {data} = await chooseSlotToBook(this.customer_id, this.selected_course_id, payload)
      if (data.data.overall_status) {
        this.overall_status = true
        this.availabilityTime = data.data.slots
      } else {
        this.overall_status = false
      }
      
    },
    async fetchTimeSlot () {
      const payload = {}
      if (this.teacher_id !== null) {
        payload.teacher_id = this.teacher_id
      }
      const { data } = await fetchEnrollmentAvailability(
        this.customer_id,
        this.selected_course_id,
        payload
      )
      this.time_slots = data.data
      this.time_error_holder_show = Array(this.time_slots.length).fill(false)
    }
  }
}
</script>